import { useEffect } from 'react';
import { Link } from 'react-router-dom';

import { PrivacyPolicyContent, TermsContent } from '../screens/settings/LegalScreen';

const PAGES = {
  privacy: { title: 'Chính sách bảo mật', Content: PrivacyPolicyContent, other: { to: '/terms', label: 'Điều khoản sử dụng' } },
  terms: { title: 'Điều khoản sử dụng', Content: TermsContent, other: { to: '/privacy', label: 'Chính sách bảo mật' } },
} as const;

/**
 * Trang pháp lý CÔNG KHAI (/privacy, /terms) — xem được khi chưa đăng nhập.
 * Đây là link khai báo trên Google Auth Platform → Branding, nên Google và người
 * dùng phải mở được trực tiếp. Nội dung dùng chung với màn trong app (LegalScreen).
 */
export function PublicLegalPage({ page }: { page: keyof typeof PAGES }) {
  const { title, Content, other } = PAGES[page];

  useEffect(() => {
    const previous = document.title;
    document.title = `${title} — Torii`;
    return () => {
      document.title = previous;
    };
  }, [title]);

  return (
    <div style={{ minHeight: '100vh', background: 'var(--surface-tint)', fontFamily: 'var(--font-vi)', padding: '32px 16px 64px' }}>
      <div style={{ maxWidth: 720, margin: '0 auto' }}>
        <Link to="/" style={{ display: 'inline-flex', alignItems: 'center', gap: 10, textDecoration: 'none', color: 'var(--ink)', fontWeight: 700, fontSize: 18 }}>
          <img src="/assets/torii-mark.svg" alt="" style={{ width: 32, height: 32 }} />
          Torii
        </Link>

        <main
          style={{
            marginTop: 20,
            background: 'var(--surface-page)',
            border: '1px solid var(--border-default)',
            borderRadius: 'var(--radius-card)',
            padding: '28px 24px',
          }}
        >
          <h1 style={{ fontSize: 24, fontWeight: 700, color: 'var(--ink)', margin: '0 0 18px' }}>{title}</h1>
          <div style={{ fontSize: 15, lineHeight: 1.75, color: 'var(--text-secondary)', display: 'flex', flexDirection: 'column', gap: 14 }}>
            <Content />
          </div>
        </main>

        <nav style={{ display: 'flex', gap: 20, marginTop: 16, fontSize: 14, fontWeight: 600 }}>
          <Link to={other.to} style={{ color: 'var(--cta-default)' }}>
            {other.label}
          </Link>
          <Link to="/" style={{ color: 'var(--cta-default)' }}>
            Mở ứng dụng Torii
          </Link>
        </nav>
      </div>
    </div>
  );
}
